/*
 * Copyright (c) 2019 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import { DataTable } from '@scuf/datatable';
import { Icon, Grid, Search, Loader, Button, Modal, Badge } from '@scuf/common';
import * as React from 'react';
import { util } from '@keystone/common';
import {
  withDeviceLogsContext,
  withApplicationContext,
  withCustomerSiteContext,
} from '../../common/HOCs';

class DisplayDeviceLogs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRow: null,
      logs: null,
      loadingSettings: false,
    };
  }

  componentDidMount() {
    const { appContext } = this.props;
    appContext.registerReloadFunction(this.reloadTableComponent);
    this.initializeTable();
    appContext.setNotification(null);
  }

  reloadTableComponent = async (signal) => {
    const logs = await this.props.deviceLogsContext.fetchAllLogs(signal);
    this.setState({ logs });
  };

  componentWillUnmount() {
    const { appContext } = this.props;
    appContext.unregisterReloadFunction();
  }

  initializeTable = async () => {
    this.setState({ loadingSettings: true });
    await this.reloadTableComponent();
    this.setState({ loadingSettings: false });
  };

  buttonTemplate = (props) => {
    return (
      <a
        onClick={() => null}
        href={
          `${util.getAPIGatewayURL()}/logs/downloadProblemLogs` +
          `?id_token=${this.props.deviceLogsContext.getIdToken()}` +
          `&selectedFile=${props.parentDir}%2F${props.fileName}` +
          `&selectedClientId=${this.props.custSiteContext.selectedCustomer}`
        }
      >
        <Icon name="file-download" size="large" />
      </a>
    );
  };

  render() {
    return (
      <div style={{ position: 'relative', height: '100%' }}>
        <Grid>
          <Grid.Row />
          <Grid.Row>
            <Grid.Column width={12}>
              <h3 />
              <Loader
                loading={this.state.loadingSettings}
                overlayOpacity={0.2}
                overlayColor="#B2AFAF"
              >
                <div className="placeholder" />
              </Loader>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={12}>
              <DataTable
                data={
                  this.state.logs === null
                    ? []
                    : this.state.logs === undefined
                    ? []
                    : this.state.logs
                }
                resizableColumns
                columnResizeMode="fit"
                reorderableColumns={false}
                selection={this.props.deviceLogsContext.selectedRow}
                onSelectionChange={(e) =>
                  this.props.deviceLogsContext.setSelectedRow({ selectedRow: e })
                }
                metaKeySelection={false}
                scrollable
                search
              >
                <DataTable.Column field="fileName" header="Log Name" sortable initialWidth={70} />
                <DataTable.Column field="parentDir" header="Device" sortable initialWidth={70} />
                <DataTable.Column
                  field="fileCreatedDate"
                  header="Recieved"
                  sortable
                  initialWidth={50}
                />
                <DataTable.Column
                  field="displayFileSize"
                  header="Size"
                  sortable
                  initialWidth={30}
                />
                <DataTable.Column
                  field="actualFileSize"
                  header="Download"
                  initialWidth={40}
                  renderer={(props) => this.buttonTemplate(props.rowData)}
                />
              </DataTable>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export default withApplicationContext(
  withCustomerSiteContext(withDeviceLogsContext(DisplayDeviceLogs))
);
